import React, { useState, useEffect, useRef } from 'react';
import { Table, Button, Form, Icon, Input, Col, Row, Avatar, Card, Divider, Radio, Rate } from 'antd';
import SignatureCanvas from 'react-signature-canvas';
import "./sigCanvas.css";
import WidgetHeader from "components/WidgetHeader/index";
import DateTimeScheduler from "../Tickets/DateTimePickerNew";
import { getData, createDataUnAuth, patchDataUnAuth } from '../../../util/API';
import { message } from "antd/lib/index";
import moment from "moment";
import CircularProgress from "components/CircularProgress/index";


function dataURItoBlob(dataURI) {
    var byteString = atob(dataURI.split(',')[1]);

    var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    var ab = new ArrayBuffer(byteString.length);
    var ia = new Uint8Array(ab);
    for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type: mimeString });


}

const { TextArea } = Input;

const CSOForm = (props) => {
    const [signature, setImageURL] = useState(null);
    const [toggle, setSteps] = useState(true);
    const [loading, setLoading] = useState(false);
    const [url_check, setURLCheck] = useState(true);
    const [form_id, setFormID] = useState("");
    const [customer_name, setCustName] = useState("");
    const [customer_phone, setCustPhone] = useState("");
    const [edit, setEdit] = useState(false);
    const [prefill_data, setPreFillData] = useState(null);
    const [error_msg, setMessage] = useState("");
    const [selecteddate, setDates] = useState("");

    const sigCanvas1 = useRef({})
    const sigCanvas2 = useRef({})

    const clear1 = () => {
        sigCanvas1.current.clear()
    }
    const clear2 = () => {
        sigCanvas2.current.clear()
    }
    const save = () => {
        setImageURL(sigCanvas1.current.getTrimmedCanvas().toDataURL("image/png"));

    }
    const desc = ['Terrible', 'Bad', 'Mediocre', 'Good', 'Excellent'];
    const columns = [
        {
            title: 'SO No / Part Req ID',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Part Number',
            dataIndex: 'age',
            key: 'age',
        },
        {
            title: 'Part Description',
            dataIndex: 'address',
            key: 'address',
        },
        {
            title: 'Removed Part CT #',
            dataIndex: 'name2',
            key: 'name2',
        },
        {
            title: 'Installed Part CT#',
            dataIndex: 'age2',
            key: 'age2',
        },
        {
            title: 'Status (Def/DOA/Good)',
            dataIndex: 'address2',
            key: 'address2',
        },
    ];

    const validatorSignature = (rule, value, callback) => {
        console.log(value, 'initials', sigCanvas1.current.isEmpty())
        if (sigCanvas1.current.isEmpty()) {

            callback("please fill this field!");
            return;
            // }
            // callback('Project Name initials already in use!');
            // })
        } else {
            callback()
        }

    }

    useEffect(() => {
        const { url_id ,ticket_id} = props.match.params
        checkUrl(url_id,ticket_id)
    }, []);


    const onDateChange = (type, value, dateString) => {

    }

    const checkUrl = (url_id,ticket_id) => {
        console.log(url_id,ticket_id)
        let endpoint = `/management/cso-url-check/?ticket_id=${ticket_id}&urlunique_id=${url_id}`;
        getData(endpoint)
            .then(res => {
                if (res.data.status===200) {
                    setURLCheck(true)
                    setPreFillData(res.data.data.status)
                    setMessage("")                }
                else {
                    setURLCheck(false)   
                    setMessage(res.data.message)
                             }
            }).catch(error => {
                message.error('Error Checking Link!', error)
                setURLCheck(false)  
                setMessage("")        
            });
    }

    const handleFormSubmit = e => {
        setLoading(true)
        e.preventDefault();
        const {ticket_id} = props.match.params
        props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                // console.log(values, 'values.......')
                const formData = new FormData()
                formData.append('slno', values.slno);
                formData.append('caseid', values.case_no);
                formData.append('serviestype', values.service_type);
                formData.append('productserialno', values.product_slno);
                formData.append('productmodelno', values.product_mno);
                formData.append('productname', values.product_name);
                formData.append('calllogdate', moment(values.call_log).format("YYYY-MM-DDThh:mm"));
                formData.append('arrivaldate', moment(values.arrival_date).format("YYYY-MM-DDThh:mm"));
                formData.append('systemfixdate', moment(values.fixed_date).format("YYYY-MM-DDThh:mm"));
                formData.append('customername', values.customer_name);
                formData.append('customercontactperson', values.customer_contact_person);
                formData.append('customerphone', values.phone_no);
                formData.append('customeraddress', values.address);
                formData.append('issuedescription', values.issue_description);
                formData.append('resolutionsummary', values.resolution_summary);
                formData.append('engineername', values.engineer_name);
                formData.append('enggsigfiles', dataURItoBlob(sigCanvas1.current.getTrimmedCanvas().toDataURL("image/png")));
                formData.append('date', moment(values.date).format("YYYY-MM-DDThh:mm"));
                formData.append('uefifailureid', values.uefi);
                formData.append('tickets',ticket_id)
                // setDate(moment(values.date).format("YYYY-MM-DDThh:mm"))


                let endpoint = '/management/cso-data/'

                createDataUnAuth(endpoint, formData)
                    .then(res => {
                        if (res.data.status === 200) {
                            message.success(res.data.message)
                            setDates(res.data.date)
                            setFormID(res.data.id)
                            setCustName(res.data.customer_name)
                            setCustPhone(res.data.customer_phone)
                            setDates(res.data.date)
                            setLoading(false)
                            clickNext()
                        }
                        else {
                            setLoading(false)
                            message.error(res.data.message)
                        }
                    }).catch(error => {
                        message.error("Error Saving Form Data! " + error.toString())
                        // console.log(error)
                        setLoading(false)
                    });
            } else {
                setLoading(false)
            }
        });
    }
    const handleFormSubmit2 = e => {
        setLoading(true)
        e.preventDefault();
        props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                // console.log(sigCanvas2.current.getTrimmedCanvas().toDataURL("image/png"), 'img',)
                // console.log(values, 'values.......')
                const formData = new FormData()
                formData.append('overallexperiance', values.overall_experience);
                formData.append('schduledate', moment(values.cust_date).format("YYYY-MM-DDThh:mm"));
                formData.append('costumercomment', values.comments);
                formData.append('custsigfiles', dataURItoBlob(sigCanvas2.current.getTrimmedCanvas().toDataURL("image/png")));


                let endpoint = '/management/cso-data/' + form_id + '/'

                patchDataUnAuth(endpoint, formData)
                    .then(res => {
                        if (res.data.status === 200) {
                            message.success(res.data.message)
                            setLoading(false)
                            props.history.push('/success')
                            //   clickNext()

                        }
                        else {
                            setLoading(false)
                            message.error(res.data.message)
                        }
                    }).catch(error => {
                        message.error("Error Saving Form Data! " + error.toString())
                        // console.log(error)
                        setLoading(false)
                    });
            } else {
                setLoading(false)
            }
        });
    }

    const clickNext = () => {
        setSteps(false)
    }

    const handleBack = () => {
        setSteps(true)
    }

    const { getFieldDecorator } = props.form;
    const formItemLayout = {
        labelCol: { xs: 24, sm: 8 },
        wrapperCol: { xs: 24, sm: 16 },
    };
    const formItemLayout2 = {
        labelCol: { xs: 24, sm: 12 },
        wrapperCol: { xs: 24, sm: 12 },
    };

    const enableEdit = () => {
        setEdit(true)
    }
    const toUpperCase = e =>{
        e.target.value = e.target.value.toUpperCase()

    }

   
    return (

        url_check ? <Card className='gx-card' title="" style={{ width: "100%", height: "100%", overflow: "auto" }} >
            {loading &&
                <div className="gx-loader-view gx-loader-position">
                    <CircularProgress />
                </div>
            }
            <Card  >
                <Row>

                    <Col lg={12} md={24} sm={24} xs={24} style={{ textAlign: "center" }} >
                        <img src="/favicon-96x96.png" ></img>
                    </Col>
                    <Col lg={12} md={24} sm={24} xs={24} style={{ textAlign: "center" }}>
                        <Avatar size={64} src="/hp.png" />
                    </Col>
                    <Col lg={8} md={24} sm={24} xs={24}  >

                    </Col>
                    <Col lg={8} md={24} sm={24} xs={24}  >
                        {/* <WidgetHeader styleName="gx-flex-row" title="Service Call Report" /> */}
                        <Divider orientation="center" style={{ fontSize: 24 }}>Service Call Report</Divider>
                        <br></br>
                        <br></br>
                    </Col>
                    <Col lg={8} md={24} sm={24} xs={24}  >
                    </Col>
                </Row>

                {/* <WidgetHeader styleName="gx-flex-row" title="Popular Agents" extra={<span>Go to agents list <i
        className="icon icon-long-arrow-right gx-fs-xxl gx-ml-2 gx-d-inline-flex gx-vertical-align-middle"/></span>}/> */}
                <Form  {...formItemLayout} onSubmit={handleFormSubmit} >
                    <Row>
                    {toggle &&<Col lg={24} md={24} sm={24} xs={24} style={{ textAlign: "right" }} >
                            <a onClick={enableEdit}><Icon type="edit" />Edit</a>
                            <br></br>
                            <br></br>
                        </Col>}
                        {toggle && <>
                            <Col lg={12} md={24} sm={24} xs={24}  >
                                <Form.Item label="Sl.No." {...formItemLayout}>
                                    {getFieldDecorator('slno', {
                                        rules: [{ required: true, message: 'Please fill the field!' }],
                                    })(<Input />)}
                                </Form.Item>
                            </Col>
                            <Col lg={12} md={24} sm={24} xs={24}  >
                                <Form.Item label="Case No." {...formItemLayout}>
                                    {getFieldDecorator('case_no', {
                                        initialValue:prefill_data?prefill_data.case_id:"",
                                        rules: [{ required: true, message: 'Please fill the field!' }],
                                    })(<Input disabled={!edit} />)}
                                </Form.Item>
                            </Col>
                            <Col lg={12} md={24} sm={24} xs={24}  >
                                <Form.Item label="Service Type" {...formItemLayout}>
                                    {getFieldDecorator('service_type', {
                                        initialValue:prefill_data?prefill_data.sowsubtype:"",
                                        rules: [{ required: true, message: 'Please fill the field!' }],
                                    })(<Input disabled={!edit} />)}
                                </Form.Item>
                            </Col>
                            <Col lg={12} md={24} sm={24} xs={24}  >
                                <Form.Item label="Product Serial Number" {...formItemLayout}>
                                    {getFieldDecorator('product_slno', {
                                        rules: [{ required: true, message: 'Please fill the field!' }],
                                    })(<Input onChange={toUpperCase}/>)}
                                </Form.Item>
                            </Col>
                            <Col lg={12} md={24} sm={24} xs={24}  >
                                <Form.Item label="Product Model Number" {...formItemLayout}>
                                    {getFieldDecorator('product_mno', {
                                        rules: [{ required: true, message: 'Please fill the field!' }],
                                    })(<Input onChange={toUpperCase} />)}
                                </Form.Item>
                            </Col>
                            <Col lg={12} md={24} sm={24} xs={24}  >
                                <Form.Item label="Product Name" {...formItemLayout}>
                                    {getFieldDecorator('product_name', {
                                        rules: [{ required: true, message: 'Please fill the field!' }],
                                    })(<Input />)}
                                </Form.Item>
                            </Col>
                            <Col lg={12} md={24} sm={24} xs={24}  >
                                <Form.Item label="Call Log Date" {...formItemLayout}>
                                    {getFieldDecorator('call_log', {
                                        initialValue:"",
                                        rules: [{ required: true, message: 'Please fill the field!' }],
                                    })(<DateTimeScheduler title="Confirm Call Log" onChange={onDateChange.bind(this, 'call_log')} />)}
                                </Form.Item>
                            </Col>
                            <Col lg={12} md={24} sm={24} xs={24}  >
                                <Form.Item label="Arrival Date" {...formItemLayout}>
                                    {getFieldDecorator('arrival_date', {
                                        initialValue:prefill_data?prefill_data.start_time:"",
                                        rules: [{ required: true, message: 'Please fill the field!' }],
                                    })(<DateTimeScheduler  title="Arrival Date" value={prefill_data?prefill_data.start_time:""} disabled={!edit} />)}
                                </Form.Item>
                            </Col>
                            <Col lg={12} md={24} sm={24} xs={24}  >
                                <Form.Item label="System Fixed Date" {...formItemLayout}>
                                    {getFieldDecorator('fixed_date', {
                                        initialValue:prefill_data?prefill_data.end_time:"",
                                        rules: [{ required: true, message: 'Please fill the field!' }],
                                    })(<DateTimeScheduler  title="System Fixed Date" value={prefill_data?prefill_data.end_time:""} disabled={!edit} onChange={onDateChange.bind(this, 'fixed_date')} />)}
                                </Form.Item>
                            </Col>
                            <Divider orientation="left" style={{ fontSize: 18 }}>Customer Details</Divider>
                            <Col lg={12} md={24} sm={24} xs={24}  >
                                <Form.Item label="Customer Name" {...formItemLayout}>
                                    {getFieldDecorator('customer_name', {
                                        initialValue:prefill_data?prefill_data.customer_name:"",
                                        rules: [{ required: true, message: 'Please fill the field!' }],
                                    })(<Input  />)}
                                </Form.Item>
                            </Col>
                            <Col lg={12} md={24} sm={24} xs={24}  >
                                <Form.Item label="Customer Contact Person" {...formItemLayout}>
                                    {getFieldDecorator('customer_contact_person', {
                                        rules: [{ required: true, message: 'Please fill the field!' }],
                                    })(<Input />)}
                                </Form.Item>
                            </Col>
                            <Col lg={12} md={24} sm={24} xs={24}  >
                                <Form.Item label="Customer Phone No" {...formItemLayout}>
                                    {getFieldDecorator('phone_no', {
                                        initialValue:prefill_data?prefill_data.customer_phone:"",
                                        rules: [{ required: true, message: 'Please fill the field!' }],
                                    })(<Input  />)}
                                </Form.Item>
                            </Col>
                            <Col lg={12} md={24} sm={24} xs={24}  >
                                <Form.Item label="Address" {...formItemLayout}>
                                    {getFieldDecorator('address', {
                                        initialValue:prefill_data?prefill_data.raw_address:"",
                                        rules: [{ required: true, message: 'Please fill the field!' }],
                                    })(
                                        <TextArea disabled={!edit} rows={4} />
                                    )}
                                </Form.Item>
                            </Col>
                            <Divider></Divider>
                            <Col lg={24} md={24} sm={24} xs={24}  ><br></br></Col>
                            <Col lg={12} md={24} sm={24} xs={24}  >
                                <Form.Item label="Issue Description" {...formItemLayout}>
                                    {getFieldDecorator('issue_description', {
                                        // initialValue:prefill_data?prefill_data.scope:"",
                                        rules: [{ required: true, message: 'Please fill the field!' }],
                                    })(
                                        <TextArea  rows={4} />
                                    )}
                                </Form.Item>
                            </Col>
                            <Col lg={12} md={24} sm={24} xs={24}  >
                                <Form.Item label="Resolution Summary" {...formItemLayout}>
                                    {getFieldDecorator('resolution_summary', {
                                        rules: [{ required: true, message: 'Please fill the field!' }],
                                    })(
                                        <TextArea rows={4} />
                                    )}
                                </Form.Item>
                            </Col>
                            <Col lg={12} md={24} sm={24} xs={24}  >
                                <Form.Item label=" Engineer Name" {...formItemLayout}>
                                    {getFieldDecorator('engineer_name', {
                                        rules: [{ required: true, message: 'Please fill the field!' }],
                                    })(<Input />)}
                                </Form.Item>
                            </Col>
                            <Col lg={12} md={24} sm={24} xs={24}  >
                                <Form.Item label="Date" {...formItemLayout}>
                                    {getFieldDecorator('date', {
                                        initialValue:"",
                                        rules: [{ required: true, message: 'Please fill the field!' }],
                                    })(<DateTimeScheduler  title="Ticket Closure Date"  onChange={onDateChange.bind(this, 'date')} />)}
                                </Form.Item>
                            </Col>
                            <Col lg={12} md={24} sm={24} xs={24}  >
                                <Form.Item label="Signature" {...formItemLayout}>
                                    {getFieldDecorator('eng-signature', {
                                        valuePropName: 'data',
                                        getValueFromEvent: (event, editor) => {
                                            // console.log(event, editor, 'ererere')
                                            const data = sigCanvas1.current.isEmpty();
                                            //  setImageURL(data);
                                            //  this.setState({scope:data})
                                            return data;
                                        },
                                        rules: [{ required: false }],
                                    })(
                                        <span>
                                            <SignatureCanvas penColor='black'
                                                canvasProps={{ className: "signatureCanvas" }}
                                                clearOnResize={false}
                                                onEnd={() => sigCanvas1.current.isEmpty()}
                                                ref={sigCanvas1} />
                                            <Button onClick={clear1} size='small'>
                                                Clear
                                            </Button>
                                        </span>
                                    )}
                                </Form.Item>
                            </Col>

                            {/* <Col lg={24} md={24} sm={24} xs={24}  >
                        <Table dataSource={[]} columns={columns} bordered />
                    </Col> */}
                            <Col lg={24} md={24} sm={24} xs={24}  ><br></br></Col>
                            <Col lg={12} md={24} sm={24} xs={24}  >
                                {/* <Form.Item label="24 Digit UEFI Failure ID" {...formItemLayout}>
                                    {getFieldDecorator('uefi', {
                                        rules: [{ required: false, message: 'Please fill the field!' }],
                                    })(<Input />)}
                                </Form.Item> */}
                            </Col>
                            <Col lg={24} md={24} sm={24} xs={24}  >
                                <Button htmlType='submit' type='primary' style={{ float: "right" }} icon="right" loading={loading}>
                                    Next
                                </Button>

                            </Col>
                        </>}
                        {!toggle && <>
                            <Col lg={24} md={24} sm={24} xs={24}  ><br></br></Col>
                            <Col lg={12} md={24} sm={24} xs={24}  >
                                <Form.Item label="Customer Name" {...formItemLayout}>
                                    {getFieldDecorator('customer_name', {
                                        rules: [{ required: false, message: 'Please fill the field!' }],
                                    })(<p>{customer_name}</p>)}
                                </Form.Item>
                            </Col>
                            <Col lg={12} md={24} sm={24} xs={24}  >
                                <Form.Item label="Customer Phone No" {...formItemLayout}>
                                    {getFieldDecorator('phone_no', {
                                        rules: [{ required: false, message: 'Please fill the field!' }],
                                    })(<p>{customer_phone}</p>)}
                                </Form.Item>
                            </Col>
                            <Col lg={12} md={24} sm={24} xs={24}  >
                                <Form.Item label="Overall service experience for this case" {...formItemLayout2}>
                                    {getFieldDecorator('overall_experience', {
                                        rules: [{ required: true, message: 'Please fill the field!' }],
                                    })(
                                        // <Radio.Group  >
                                        //     <Radio value={"happy"}> <Avatar src='/smile.jpeg' /></Radio>
                                        //     <Radio value={"mediocre"}><Avatar src='/neutral.jpeg' /></Radio>
                                        //     <Radio value={"sad"}><Avatar src='/sad.jpeg' /></Radio>

                                        // </Radio.Group>
                                        <Rate  tooltips={desc}  />
                                    )}
                                </Form.Item>
                            </Col>
                            {/* <Col lg={12} md={24} sm={24} xs={24}  >
                        <Form.Item label=" Customer Name" {...formItemLayout}>
                            {getFieldDecorator('customer_name', {
                                rules: [{ required: true, message: 'Please fill the field!' }],
                            })(<Input />)}
                        </Form.Item>
                    </Col> */}
                            <Col lg={12} md={24} sm={24} xs={24}  >
                                <Form.Item label={"Date"} {...formItemLayout}>
                                    {getFieldDecorator('cust_date', {
                                        initialValue:selecteddate,
                                        rules: [{ required: true, message: 'Please fill the field!' }],
                                    })(<DateTimeScheduler value={selecteddate} title="Ticket Closure Date" onChange={onDateChange.bind(this, 'cust_date')} />)}
                                </Form.Item>
                            </Col>
                            <Col lg={12} md={24} sm={24} xs={24}  >
                                <Form.Item label=" Customer Comments" {...formItemLayout}>
                                    {getFieldDecorator('comments', {
                                        rules: [{ required: true, message: 'Please fill the field!' }],
                                    })(
                                        <TextArea rows={7} />
                                    )}
                                </Form.Item>
                            </Col>
                            <Col lg={12} md={24} sm={24} xs={24}  >
                                <Form.Item label="Signature" {...formItemLayout}>
                                    {getFieldDecorator('signature', {
                                        valuePropName: 'data',
                                        getValueFromEvent: (event, editor) => {
                                            console.log(event, editor, 'ererere')
                                            const data = sigCanvas2.current.isEmpty();
                                            //  setImageURL(data);
                                            //  this.setState({scope:data})
                                            return data;
                                        },
                                        rules: [{ required: false }],
                                    })(
                                        <span>
                                            <SignatureCanvas penColor='black'
                                                canvasProps={{ className: "signatureCanvas" }}
                                                clearOnResize={false}
                                                onEnd={() => sigCanvas2.current.isEmpty()}
                                                ref={sigCanvas2} />
                                            <Button onClick={clear2} size='small'>
                                                Clear
                                            </Button>
                                        </span>
                                    )}
                                </Form.Item>
                            </Col>
                            <Col lg={24} md={24} sm={24} xs={24}  >
                                {/* <Button onClick={handleBack} type='primary' icon="left" style={{ float: "left" }}>
                                    Back
                                </Button> */}
                                <Button onClick={handleFormSubmit2} type='primary' style={{ float: "right" }} loading={loading}>
                                    Save
                                </Button>

                            </Col>
                        </>}
                    </Row>
                </Form>
            </Card>
        </Card> :
            <Card className='gx-card'>
                <Row>
                    <Col lg={24} md={24} sm={24} xs={24} style={{ textAlign: "center" }} >
                        <h2 style={{ color: "red" }}>{error_msg}</h2>
                    </Col>
                </Row>
            </Card>
    )
}

export default Form.create()(CSOForm);